import { Vector3 } from 'three';
import * as THREE from 'three/build/three.module';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import { J3RenderUtils } from './J3RenderUtils';
import { CameraAnimationType, CameraAnimationKeyPolar } from './J3TypeList';

export class J3CameraUtils extends EventTarget {
    camera: THREE.Camera = null;
    controls: THREE.OrbitControls = null;
    controlRadius = 0.1;    //OrbitControlの中心からカメラまでの距離
    gyrocontrols;
    initialAutoRotateSpeed: number = 0.0;
    faceToCamera: boolean = false;
    updateControls: boolean = false;
    orbitRotDirection: number = 1.0;
    orbitRotSpeed: number = 1.0;   //Rotation Speed Factor
    applyAnimation: boolean = false;
    animParam = null;  //アニメーションのパラメータ
    keyIndex: number = 0;    //アニメーションキーデータのインデックス 初期値0

    constructor(public renderUtils: J3RenderUtils, public fov = 60.0, public aspect = 1.0, public initialPos = [0, 0, -10], public initialLookAt = [0, 0, 0], public near = 1.0, public far = 1000.0) {
        super();

        // カメラを作成　アスペクト比はOnWindowResize()で調整
        this.camera = new THREE.PerspectiveCamera(
            fov,
            aspect,
            near,
            far
        );
        //console.log('MakeCamera', this.initialPos, this.initialLookAt);
        this.ResetCamera();
        //this.renderUtils.OnWindowResize();
    }

    Update(forceUpdate = false) {
        //カメラコントローラのアップデート
        //console.log('J3CameraUtils.Update()');
        if (forceUpdate || this.updateControls) {
            if (this.controls) this.controls.update();
        }
    }

    ResetCamera() {
        //カメラを初期位置に戻す
        //console.log('ResetCamera', this.initialPos, this.initialLookAt);
        this.camera.position.set(this.initialPos[0], this.initialPos[1], this.initialPos[2]);
        this.camera.lookAt(this.initialLookAt);
        this.camera.fov = this.fov;
        this.camera.aspect = window.innerWidth / window.innerHeight;
        this.camera.updateProjectionMatrix();
        //this.renderUtils.OnWindowResize();
    }

    ResetAspect() {
        // カメラのアスペクト比を変更
        this.camera.aspect = window.innerWidth / window.innerHeight;
        this.camera.updateProjectionMatrix();
        //this.renderUtils.OnWindowResize();
    }

    MoveCameraTo(targetPos: Vector3) {
        this.camera.position.set(targetPos);    //ターゲットに近づける
        this.controls.target.addScaledVector(targetPos);    //ターゲットに近づける
    }

    LookAt(targetPos: Vector3) {
        this.camera.lookAt(targetPos);
    }
    LookAtControlTarget() {
        this.camera.lookAt(this.controls.target);
    }

    SetOrbitPosition(pos: number[] = [0, 0, 0], offset: number[] = [0, 0, 1], radius: number = 1.0) {
        console.log('SetOrbitPosition');
        this.controls.target.set(pos[0], pos[1], -pos[2]);
        this.camera.position.set(pos[0] + offset[0], pos[1] + offset[1], -pos[2] + offset[2]);
    }


    SetOrbitControls(container: HTMLElement, pos: number[] = [0, 0, 0], offset: number[] = [0, 0, -10], enableZoom: boolean = true, enablePan: boolean = false, enableDamping: boolean = false, dampingFactor: number = 0.2, minDistance: number = 100, maxDistance: number = 3000, minPolarAngle: number = 0.0, maxPolarAngle: number = Math.PI / 2, rotateSpeed: number = 1.0, autoRotate: false = false, autoRotateSpeed: number = 2.0) {
        const dom = container as THREE.HTMLDOMElement;
        this.controls = new OrbitControls(this.camera, dom);

        const radius = Math.sqrt((pos[0] - offset[0]) ** 2 + (pos[1] - offset[1]) ** 2 + (pos[2] - offset[2]) ** 2);
        console.log('SetOrbitControls', pos, radius, offset, this.camera.position);
        this.controlRadius = radius;    //OrbitControlの回転半径（初期値）
        this.controls.target.set(pos[0], pos[1], -pos[2]);
        console.log('orbit camera position', pos[0] + offset[0], pos[1] + offset[1], -pos[2] + offset[2]);
        this.camera.position.set(pos[0] + offset[0], pos[1] + offset[1], -pos[2] + offset[2]);

        this.ChangeOrbitControlParam(enableZoom, enablePan, enableDamping, dampingFactor, minDistance, maxDistance, minPolarAngle, maxPolarAngle, rotateSpeed, autoRotate, autoRotateSpeed);
    }

    ChangeOrbitControlParam(enableZoom = true, enablePan = false, enableDamping = false, dampingFactor = 0.2, minDistance = 100, maxDistance = 3000, minPolarAngle = 0.0, maxPolarAngle = Math.PI / 2, rotateSpeed = 1.0, autoRotate = false, autoRotateSpeed = 2.0) {
        //console.log('SetOrbitControls');
        this.controls.tiltEnabled = true;    // Enable Gyro
        this.controls.enableZoom = enableZoom;
        this.controls.enablePan = enablePan;
        this.controls.rotateSpeed = rotateSpeed;  //負値はMacライクなドラッグ
        this.controls.enableDamping = enableDamping;
        this.controls.dampingFactor = dampingFactor;
        this.controls.minDistance = minDistance;
        this.controls.maxDistance = maxDistance;
        this.controls.minPolarAngle = minPolarAngle;
        this.controls.maxPolarAngle = maxPolarAngle;
        this.controls.autoRotate = autoRotate;
        this.initialAutoRotateSpeed = autoRotateSpeed;  //回転速度の初期値
        this.controls.autoRotateSpeed = autoRotateSpeed;
        this.controls.update();
        //this.gyrocontrols = new DeviceOrientationControls(this.camera);
        //OritControlを設定するとカメラ位置は変わってしまう!
        //console.log('SetOrbitControls', this.camera.position, this.camera.rotation);
    }

    //SetOrbitAutoRotation(speedFactor = 1.0) {
    //    this.controls.autoRotateSpeed = this.initialAutoRotateSpeed * speedFactor;
    //}

    SetOrbitDirection(direction: string) {
        if (direction == 'CW') {
            this.orbitRotDirection = 1.0;
        } else if (direction == 'CCW') {
            this.orbitRotDirection = -1.0;
        } else {
            this.orbitRotDirection = 0.0;
        }
        this.controls.autoRotateSpeed = this.orbitRotDirection * this.orbitRotSpeed;
    }
    SetOrbitSpeed(speedFactor = 1.0) {
        this.orbitRotSpeed = this.initialAutoRotateSpeed * speedFactor;
        this.controls.autoRotateSpeed = this.orbitRotDirection * this.orbitRotSpeed;
    }

    //カメラ・アニメーション 2022/12/7 追加
    SetAnimation(animationParam = null) {
        if (animationParam != null) {
            this.animParam = animationParam;    //アニメーションのパラメータをクラス変数に指定
            this.UpdateAnimation(0);
        }
    }

    UpdateAnimation(time: number = 0) {
        const type: CameraAnimationType = this.animParam.type;
        if (type == 'polar') {
            //console.log('polar', time);
            this.InterpolateAnimationParamPolar(time, this.animParam.restriction);
        } else {
            console.error('Inconsistent Animation Type');
        }

    }

    MakeVector3fromArray(array: number[]): THREE.Vector3 {
        //３要素の配列からVector3を作る
        if (array.length < 3) {
            //console.error('Array.length', array.length, '< 3');
            return null;
        } else {
            return new Vector3(array[0], array[1], array[2]);
        }
    }

    PolarToCartesian(radius: number, phi: number, theta: number, offset:THREE.Vector3 = new THREE.Vector3(0,0,0)): THREE.Vector3 {
        //console.log('PolarToCartesian', radius, phi, theta);
        const f = Math.PI / 180.0;    //°→radianの変換係数
        const cy = radius * Math.sin(f * phi);
        const cr = radius * Math.cos(f * phi);
        const cx = cr * Math.cos(f * theta);
        const cz = cr * Math.sin(f * theta);
        const vec = new THREE.Vector3(cx, cy, cz);
        return vec.add(offset);
    }

    InterpolateAnimationParamPolar(t: number = 0, restriction=null) {
        const type: CameraAnimationType = this.animParam.type;
        if (type != 'polar') return null;

        //console.log('polar t=', t);
        const keys: CameraAnimationKeyPolar = this.animParam.keys;
        if (Array.isArray(keys)) {
            let time: number = keys[this.keyIndex].time;
            let alpha:number = 0;
            let radius:number = keys[this.keyIndex].radius;
            let phi:number = keys[this.keyIndex].phi;
            let theta:number = keys[this.keyIndex].theta;
            let offset:THREE.Vecter3 = this.MakeVector3fromArray(keys[this.keyIndex].offset);
            let lookAt:THREE.Vector3 = this.MakeVector3fromArray(keys[this.keyIndex].lookAt);
            for (const [index, key] of keys.entries()) {
                if (index > this.keyIndex) {
                    const radius2 = key.radius;
                    const phi2 = key.phi;
                    const theta2 = key.theta;
                    const offset2:THREE.Vecter3 = this.MakeVector3fromArray(key.offset);
                    const lookAt2:THREE.Vector3 = this.MakeVector3fromArray(key    .lookAt);
                    if (key.time > t) {
                        alpha = (t - time) / (key.time - time);
                        radius = (radius2 - radius) * alpha + radius;
                        phi = (phi2 - phi) * alpha + phi;
                        theta = (theta2 - theta) * alpha + theta;
                        offset = offset2.sub(offset).multiplyScalar(alpha).add(offset);
                        lookAt = lookAt2.sub(lookAt).multiplyScalar(alpha).add(lookAt);
                        if(restriction?.apply){
                            if(radius < restriction.minRadius) radius = restriction.minRadius;
                            if(radius > restriction.maxRadius) radius = restriction.maxRadius;
                        }
                        //console.log(this.keyIndex, 'in  t=', t.toFixed(2), alpha.toFixed(3), radius.toFixed(2), phi.toFixed(2), theta.toFixed(2));
                        
                        this.camera.position.copy(this.PolarToCartesian(radius, phi, theta, offset));
                        this.camera.lookAt(lookAt);
                        return;
                    }else{
                        this.keyIndex = index;
                        return;
                    }
                };
            };
            /*
            //キーのtimeが対称時間以下の場合は外挿
            if (keys.length > 1) {
                const key1 = keys[keys.length - 2]
                const key2 = keys[keys.length - 1];
                alpha = (t - key1.time) / (key2.time - key1.time);  //alpha > 1 （外挿）
                radius = (key2.radius - key1.radius) * alpha + key1.radius;
                phi = (key2.phi - key1.phi) * alpha + key1.phi;
                theta = (key2.theta - key1.theta) * alpha + key1.theta;
                if(restriction?.apply){
                    if(radius < restriction.minRadius) radius = restriction.minRadius;
                    if(radius > restriction.maxRadius) radius = restriction.maxRadius;
                }
                console.log('ex t=', t.toFixed(2), alpha.toFixed(2), radius.toFixed(2), phi.toFixed(2), theta.toFixed(2));
                this.camera.position.copy(this.PolarToCartesian(radius, phi, theta));
            }
            */
        }
    }
}